import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextMedium } from 'UiKit/typography';
import Drawer from 'UiKit/drawer';
import { CloseIcon } from 'Asset/icon';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const DrawerInfo = ({ isOpen, onClose }) => {
  const { t } = useTranslation('host-achievement');

  const terms = [
    { title: t('info_drawer.gmv_title'), desc: t('info_drawer.gmv_desc') },
    { title: t('info_drawer.aov_title'), desc: t('info_drawer.aov_desc') },
    { title: t('info_drawer.ctr_title'), desc: t('info_drawer.ctr_desc') },
    { title: t('info_drawer.ctor_title'), desc: t('info_drawer.ctor_desc') },
    { title: t('info_drawer.err_title'), desc: t('info_drawer.err_desc') },
    { title: t('info_drawer.views_title'), desc: t('info_drawer.views_desc') },
  ];

  return (
    <Drawer className={styles['drawer__container']} height="60vh" isOpen={isOpen} onClose={onClose}>
      <Box className={styles['section__head']}>
        <TextBold className={styles['section__title']}>{t('info_drawer.title')}</TextBold>
        <CloseIcon size="18px" onClick={onClose} />
      </Box>

      <Box className={styles['section__content']}>
        <Box className={styles['content__item']}>
          <TextMedium className={styles['intro__text']}>{t('info_drawer.desc')}</TextMedium>
          <Iteration
            items={terms}
            render={(term, index) => (
              <Flex flexDirection="column" key={index}>
                <TextBold className={styles['title__text']}>{term.title}</TextBold>
                <TextMedium className={styles['desc__text']}>{term.desc}</TextMedium>
              </Flex>
            )}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerInfo;
